module.exports = __webpack_public_path__ + "fonts/0afd696.otf";